import React from 'react';
import * as PropTypes from 'prop-types';

import Button from '../../../../../Button';
import SignConsentButton from '../SingConsentButton';
import { renderConsentHeader } from '../../utils/renderConsentHeader';

import styles from '../index.styl';

export function ConsentDetailsMainView({
  buttonAccept,
  buttonDecline,
  consentOutcomeTitles,
  convertedTime,
  createMarkup,
  formatMessage,
  handleAcceptConsent,
  handleClosePopup,
  isConsentHasMultipleOutcomes,
  isSignConsentLoading,
  name,
  organizationName,
  serviceName,
  titleTypeConsent,
}) {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        {renderConsentHeader(
          formatMessage,
          titleTypeConsent,
          organizationName,
          serviceName,
          convertedTime,
          true,
          name,
        )}
      </div>
      <div className={styles.mainConsentContent}>
        {/* eslint-disable-next-line react/no-danger */}
        <div className={styles.text} dangerouslySetInnerHTML={createMarkup()} />
        <div className={styles.mainConsentBtnWrapper}>
          <Button
            className={styles.declineButton}
            onClick={handleClosePopup}
            color="accent"
          >
            {buttonDecline}
          </Button>
          <SignConsentButton
            buttonAccept={buttonAccept}
            handleAcceptConsent={handleAcceptConsent}
            isConsentHasMultipleOutcomes={isConsentHasMultipleOutcomes}
            isSignConsentLoading={isSignConsentLoading}
            titles={consentOutcomeTitles}
          />
        </div>
      </div>
    </div>
  );
}

ConsentDetailsMainView.propTypes = {
  buttonAccept: PropTypes.string,
  buttonDecline: PropTypes.string,
  consentOutcomeTitles: PropTypes.arrayOf(PropTypes.string),
  convertedTime: PropTypes.string,
  createMarkup: PropTypes.func,
  formatMessage: PropTypes.func,
  handleAcceptConsent: PropTypes.func,
  handleClosePopup: PropTypes.func,
  isConsentHasMultipleOutcomes: PropTypes.bool,
  isSignConsentLoading: PropTypes.bool,
  name: PropTypes.string,
  organizationName: PropTypes.string,
  serviceName: PropTypes.string,
  titleTypeConsent: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentDetailsPopup/ConsentDetailsMainView/index.jsx